var exports = {
  "Tp": "x31de4314--17bf60--background",
  "KI": "x31de4314--17bf60--icon_container",
  "Kk": "x31de4314--17bf60--icon",
  "rV": "x31de4314--17bf60--click_area",
  "q9": "x31de4314--17bf60--click_area--left",
};

module.exports = exports;
